import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCloudCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M1 14C1 17.3137 3.68629 20 7 20H17C20.3137 20 23 17.3137 23 14C23 11.1691 21.0394 8.79604 18.402 8.16469C17.3138 5.7113 14.8568 4 12 4C9.14324 4 6.68617 5.7113 5.59801 8.16469C2.96058 8.79604 1 11.1691 1 14ZM16.06 10.4634L14.9634 9.43997L10.3333 14.4008L8.03655 11.94L6.93997 12.9634L10.3333 16.5992L16.06 10.4634Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloudCheck;
